import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { useTranslation } from 'react-i18next';
import AccomodationIcon from "assets/svgs/accomodationIconBlack.svg";
import StandByIcon from "assets/svgs/standbyIconBlack.svg";
import LeftHandedIcon from "assets/svgs/leftHandedIconBlack.svg";
import OnlineIcon from "assets/svgs/onlineIconBlack.svg";
import NoPhoto from "assets/svgs/noPhoto.svg";
import * as rostersActions from "features/rosters/duck";
import { isEmpty } from "lodash";

import { ModalInfo, Spinner, ExamineeDetails } from "shared/components";
import "./StudentDetailsModal.scss";
import { ASSIGNED_STATUS } from "shared/constants";

const StudentDetailsModal = ({
  student,
  modalIsOpen,
  closeModal,
  nowManagedFlag,
}) => {
  const { t } = useTranslation();
  const width = window.innerWidth;
  const isMobile = width < 768;
  const { examinee, examineePhoto, examineePhotoLoading } = useSelector(
    (state) => ({
      examinee: state.rosters.currentExaminee,
      examineePhoto: state.rosters.currentExamineePhoto,
      examineePhotoLoading: state.rosters.examineePhotoLoading,
      stateStudentId: state.rosters.stateStudentId,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (modalIsOpen) {
      if (!nowManagedFlag) {
        dispatch(rostersActions.getExamineePhoto(student.id));
      }
      dispatch(rostersActions.getExamineeDetails(student.id));
    }
  }, [student]);

  useEffect(() => {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach(
      (el) => bootstrap.Popover.getOrCreateInstance(el).enable()
    );
  }, []);

  const getDeniedStatus = (denied) => {
    let reason = denied;
    if (reason === "other") {
      reason = "";
    }
    if (reason === "no_id") {
      return t("rosters.noId");
    }
    return reason ? `${reason.charAt(0).toUpperCase()}${reason.slice(1)}` : "";
  };

  return (
    <div>
      <ModalInfo
        containerClass="student-details-modal-container"
        onSubmit={closeModal}
        closeModal={closeModal}
        modalIsOpen={modalIsOpen && !isEmpty(examinee)}
        headerTitle="rosters.examineeModal.header"
        saveLabel="common.labels.back"
        className="student-details-modal"
      >
        <React.Fragment>
          <div
            className={`details-section ${nowManagedFlag ? "full-width" : ""}`}
          >
            <div>
              {!nowManagedFlag && isMobile && (
                <div className="image-container">
                  {examineePhotoLoading ? (
                    <Spinner />
                  ) : examineePhoto ? (
                    <img
                      src={`data:image/png;base64,${btoa(
                        new Uint8Array(examineePhoto).reduce(
                          (data, byte) => data + String.fromCharCode(byte),
                          ""
                        )
                      )}`}
                    />
                  ) : (
                    <NoPhoto />
                  )}
                </div>
              )}
              <div className="header-section">
                <h4>
                  <span className="examinee-name">
                    {examinee.lastName}, {examinee.firstName}{" "}
                    {examinee.middleName}{" "}
                  </span>
                  {examinee.absentFlag && (
                    <div className="attendance-details d-inline-block">
                      {t("rosters.absent")}
                    </div>
                  )}
                  {examinee.deniedReason && (
                    <div
                      className="attendance-details d-inline-block"
                      tabIndex="0"
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-trigger="hover"
                      data-boundary="window"
                      data-bs-html
                      data-bs-content={`<div>
                        <div>${getDeniedStatus(examinee.deniedReason)}</div>
                        <div>${getDeniedStatus(
                          examinee.deniedReasonDetails
                        )}</div>
                      </div>`}
                    >
                      {t("rosters.denied")}
                    </div>
                  )}
                  {examinee.standbyFlag && (
                    <span className="icons d-inline-block">
                      <StandByIcon />
                    </span>
                  )}
                  {examinee.onlineFlag && (
                    <span className="icons d-inline-block">
                      <OnlineIcon />
                    </span>
                  )}
                  {examinee.accomRosterFlag && (
                    <span className="icons d-inline-block">
                      <AccomodationIcon />
                    </span>
                  )}
                  {examinee.leftHandedFlag && (
                    <span className="icons d-inline-block">
                      <LeftHandedIcon />
                    </span>
                  )}
                </h4>
                <div className=" dark-gray fw-bold">
                  {examinee.roomName
                    ? examinee.roomName
                    : ASSIGNED_STATUS.notAssigned}
                </div>
                <div className="student-labels font-size-12">
                  <div className="">{examinee.regType}</div>
                  {examinee.timing && (
                    <div className="text-capitalize">{examinee.timing}</div>
                  )}
                  <div>
                    {examinee.onlineFlag
                      ? t("common.labels.online")
                      : t("common.labels.paper")}
                  </div>
                </div>
              </div>
            </div>
            <ExamineeDetails
              examinee={examinee}
              nowManagedFlag={nowManagedFlag}
            />
          </div>
          {!nowManagedFlag && !isMobile && (
            <div className="image-container">
              {examineePhotoLoading ? (
                <Spinner />
              ) : examineePhoto ? (
                <img
                  src={`data:image/png;base64,${btoa(
                    new Uint8Array(examineePhoto).reduce(
                      (data, byte) => data + String.fromCharCode(byte),
                      ""
                    )
                  )}`}
                />
              ) : (
                <NoPhoto />
              )}
            </div>
          )}
          {!isEmpty(examinee.accommodations) && (
            <div className="accommodations">
              <div>{t("rosters.accommodations")}</div>
              <div>
                <ul>
                  {examinee.accommodations.map((item, i) => (
                    <li key={i}>{item.name}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </React.Fragment>
      </ModalInfo>
    </div>
  );
};

export default StudentDetailsModal;
